import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router';
import i18n from 'kodyl-js/i18n/react';
import { getNumberFormat, formatDate, slugify } from '../../utils/format';

const SPECIALS = ['rooms', 'rent', 'size'];

const NUMBER_PATTERN = /^[0-9]+$/;
const DATE_PATTERN = /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/;

function booleanString(bool) {
  if (bool === 1) {
    return 'Ja';
  }
  if (bool === -1) {
    return 'Nej';
  }
  return '-';
}

@i18n
class Icon extends Component {
  static propTypes = {
    stack: PropTypes.bool,
    type: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.array
    ])
  };

  formatMoney(amount) {
    const locale = this.context.i18n.lang;
    const fmt = getNumberFormat(
      {
        locale,
        options: {
          style: 'currency',
          currency: 'DKK',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }
      },
      `${locale}-currency`
    );
    return fmt(amount);
  }

  formatNumber(number, decimals = 0) {
    const locale = this.context.i18n.lang;
    const fmt = getNumberFormat(
      {
        locale,
        options: {
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals
        }
      },
      `${locale}-decimals-${decimals}`
    );
    return fmt(number);
  }

  getIconData(type) {
    switch (type) {
      case 'rent':
        return {
          label: this.i18n('Rent'),
          class: 'money',
          suffix: this.i18n(' kr/md')
        };
      case 'rooms':
        return {
          label: this.i18n('Rooms'),
          class: 'floorplan',
          suffix: this.i18n(' rooms')
        };
      case 'size':
        return { label: this.i18n('Size'), class: 'm2' };
      case 'pets':
        return { label: this.i18n('Pets') };
      case 'city':
        return { label: this.i18n('City'), class: 'city' };
      case 'street':
        return { label: this.i18n('Street'), class: 'address' };
      case 'expenses_heat':
        return { label: this.i18n('Heating'), class: 'money' };
      case 'expenses_water':
        return { label: this.i18n('Water'), class: 'money' };
      case 'expenses_electricity':
        return { label: this.i18n('Electricity'), class: 'money' };
      case 'expenses_tv':
        return { label: this.i18n('TV'), class: 'money' };
      case 'expenses_internet':
        return { label: this.i18n('Internet'), class: 'money' };
      case 'expenses_misc':
        return { label: this.i18n('Misc. expenses'), class: 'money' };
      case 'expenses':
      case 'expenses_ac':
        return { label: this.i18n('Expenses'), class: 'money' };
      case 'prepaid_rent':
        return { label: this.i18n('Prepaid rent'), class: 'money' };
      case 'deposit':
        return { label: this.i18n('Deposit'), class: 'money' };
      case 'downpayment':
        return { label: this.i18n('Downpayment'), class: 'money' };
      case 'houses':
        return { label: this.i18n('Houses'), class: 'houses' };
      case 'dwelling_types':
        return { label: this.i18n('Dwelling type'), class: 'houses' };
      case 'available':
        return { label: this.i18n('Available from'), class: 'calendar' };
      case 'timeframe':
        return { label: this.i18n('Time limited'), class: 'clock' };
    }

    return {};
  }

  outputValue(type, value, data) {
    if (SPECIALS.indexOf(type) !== -1) {
      if (value === -1) {
        return <em>{this.i18n('ukendt')}</em>;
      }
      if (type === 'size') {
        return (
          <span>
            {this.formatNumber(value)} m<sup>2</sup>
          </span>
        );
      }
      return `${this.formatNumber(value)}${data.suffix}`;
    }

    if (type === 'city') {
      return <Link to={`/${slugify(value)}`}>{value}</Link>;
    }
    if (type === 'pets') {
      return booleanString(value);
    }
    if (type === 'available' && value) {
      return formatDate(new Date(value));
    }
    if (type === 'timeframe' && Array.isArray(value)) {
      if (!value[0] && DATE_PATTERN.test(value[1])) {
        return this.i18n('Until %s', formatDate(new Date(value[1])));
      }
      if (NUMBER_PATTERN.test(value[0]) && NUMBER_PATTERN.test(value[1])) {
        if (!(value[0] % 12) && !(value[1] % 12)) {
          return this.i18n(
            '%s - %s %s',
            value[0] / 12,
            value[1] / 12,
            this.i18n('years')
          );
        }
        return this.i18n('%s - %s %s', value[0], value[1], this.i18n('months'));
      }
      return null;
    }

    if (!value) {
      return null;
    }

    return typeof value === 'string'
      ? value
      : data.class === 'money'
      ? this.formatMoney(value)
      : this.formatNumber(value);
  }

  render() {
    const { type, value, stack, grid } = this.props;
    const data = this.getIconData(type);
    const output = this.outputValue(type, value, data);

    if (output === null) {
      return null;
    }

    const className =
      type !== 'pets' ? `fa ico ico-${data.class}` : 'fa fa-paw';
    // const icon = <i className={className} />;

    return (
      <li className={`col-xs-${grid || 4}`}>
        {stack ? (
          <span>
            <span className="ico-stack">
              <i className={className} />
            </span>
            <span>
              <small>{data.label}</small>
              {output}
            </span>
          </span>
        ) : (
          <span>
            <i className={className} />
            <span>{output}</span>
          </span>
        )}
      </li>
    );
  }
}

export default Icon;
